class V12BottomContent extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['data']
  }

  connectedCallback () {
    super.connectedCallback()

    this.html = JSON.parse(this.els.data.element.textContent)
    if (!this.html) return

    this.inject()

    this.observer = new MutationObserver(this.inject)
    this.observer.observe(document.body, { childList: true, subtree: true })
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.observer) this.observer.disconnect()
  }

  setupListeners () {
    this.inject = this.inject.bind(this)
  }

  inject () {
    document.querySelectorAll('.autify-osm__monthly').forEach((el) => {
      if (el.querySelector(':scope > .v12-bottom-content')) return

      const wrapper = document.createElement('div')
      wrapper.className = 'v12-bottom-content'
      wrapper.innerHTML = this.html
      el.prepend(wrapper)
    })
  }
}

if (!customElements.get('v12-bottom-content')) {
  customElements.define('v12-bottom-content', V12BottomContent)
}
